import React from 'react';

const StructuredData = ({ data }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
};

// Event structured data generator
export const generateEventSchema = (event) => {
  const { fields } = event;
  const eventDate = new Date(fields.date);
  const isPastEvent = eventDate <= new Date();
  
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": fields.title,
    "description": fields.description,
    "startDate": fields.date,
    "endDate": fields.endDate || fields.date,
    "eventStatus": isPastEvent ? "https://schema.org/EventCompleted" : "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "location": {
      "@type": "Place",
      "name": fields.location,
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "BG"
      }
    },
    "organizer": {
      "@type": "Organization",
      "name": "Refresh Bulgaria",
      "url": "https://refreshbulgaria.com"
    },
    "image": fields.mainImage ? `https://refreshbulgaria.com${fields.mainImage}` : "https://refreshbulgaria.com/img/logo.png",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "BGN",
      "availability": "https://schema.org/InStock"
    }
  };
};

// Article structured data generator
export const generateArticleSchema = (title, description, author = 'Refresh Bulgaria', publishedDate = new Date().toISOString()) => {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": title,
    "description": description,
    "author": {
      "@type": "Organization",
      "name": author
    },
    "publisher": {
      "@type": "Organization",
      "name": "Refresh Bulgaria",
      "logo": {
        "@type": "ImageObject",
        "url": "https://refreshbulgaria.com/img/logo.png"
      }
    },
    "datePublished": publishedDate,
    "dateModified": publishedDate
  };
};

export default StructuredData; 